import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("il_"), S.String).pipe(S.brand("@open-revenue/schema/stripe/InvoiceLineId"), S.annotations({
    identifier: "@open-revenue/schema/stripe/InvoiceLineId",
    description: "The id of the invoice line in Stripe",
    examples: [
        "il_1234567890"
    ]
}));
export const make = (invoiceLineId)=>S.decodeUnknown(Schema)(invoiceLineId);
export const makeUnsafe = (invoiceLineId)=>invoiceLineId;
